// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"bb3bbe6d","974":"f0f5ea40"}[chunkId] + ".chunk.css";
};